import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import Toast from '../components/ui/notification/Toast.vue';

const firebaseConfig = {
  apiKey: "AIzaSyB6g8Z9vTrQJVVr0432sc0JHVHqjAx9vbg",
  authDomain: "faseyhapos.firebaseapp.com",
  projectId: "faseyhapos",
  storageBucket: "faseyhapos.firebasestorage.app",
  messagingSenderId: "631319067",
  appId: "1:631319067:web:030c67b68e9884ec4e66be",
  measurementId: "G-7HMD46HR6P"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: 'BH_sxkTPxE3tnbfx-xxHrCnTp-VJg-l-bn4nH4M2X0_Pb_2qjdS1Q35YAx3tt9j-GN3rfgPkphf2yAjBtMV9B3w' // You'll need to replace this with your actual VAPID key
      });
      return token;
    }
    return null;
  } catch (error) {
    Toast.error('Error requesting notification permission');
    return null;
  }
};

export const onMessageListener = () => {
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
};